import './ClassProductsPage.scss'

import {RightCircleFilled, ShoppingCartOutlined} from '@ant-design/icons'
import {Alert, Button, Collapse, Input, Modal, notification, Select} from 'antd'
import {NotificationPlacement} from 'antd/es/notification/interface'
import {AppRoutes} from 'App'
import CenteredLayout from 'components/centered-layout/CenteredLayout'
import GroupProductsTab from 'components/class-group-products-tab/GroupProductsTab'
import ClassProductsTable from 'components/class-products-table/ClassProductsTable'
import {SchoolClothesPage} from 'components/class-products-table/school-clothes-page/SchoolClothesPage'
// import GroupProductsTable from 'components/class-group-products-table/GroupProductsTable'
import Spinner from 'components/spinner/Spinner'
import AppContext from 'context/AppContext'
import {
    SepetDocument,
    SinifUrunu,
    UrunGrubu,
    useSepetePaketEkleMutation,
    useSepetiBosaltMutation,
    useSepetQuery,
    useSinifSecimSifreMutation,
    useSinifUrunleriTestQuery,
} from 'gql/GeneratedGraphqlTypes'
import infoImg from 'images/info.png'
import tabTekstilImg from 'images/tab_tekstil.png'
import tabKirtasiyeImg from 'images/tab-kirtasiye.png'
import React, {useContext, useEffect, useRef, useState} from 'react'
import {Link, useNavigate, useParams} from 'react-router-dom'
import {ETIKET_URUN_ID} from 'utils/const'
import { getEffectiveMaxAdet } from 'utils/helpers'

import GroupProductsTabTekstil from '../../components/class-group-products-tab/GroupProductsTabTekstil'
import modalCantaImg from './images/bag.png'
import modalKalemImg from './images/pencil.png'
import modalKalemKutuImg from './images/pencil-case.png'
import modalMataraImg from './images/water-bottle.png'

interface TabData {
    label: JSX.Element
    className: string
    key: string
    content: JSX.Element
}

export type SecilenUrun = {
    isim: string
    urunId: number
    dersId: number
    adet: number
    minAdet: number
    maxAdet?: number | null
    fiyat: string
    kisa_aciklama: string
    resimler: any[]
    indirimsiz_birim_fiyat?: string
    indirimli_birim_fiyat?: string
    grupId: number | null
    zorunlulukGrubu: number | null
    secilenBeden: string | null
    etiket_bilgisi: string | null
    kitapKaplama: number | null
    grup: UrunGrubu
}

function ClassProductsPage() {
    const params = useParams()
    const {slug} = useContext(AppContext)
    const sinifId = params.classId ? parseInt(params.classId) : 0
    const [activeTab, setActiveTab] = useState<number>(0)
    const [innerTabKey, setInnerTabKey] = useState<string>('1')
    const [kitapTabVisited, setKitapTabVisited] = useState<boolean>(false)
    const [lessonGrouping, setLessonGrouping] = useState<boolean>(true) // Sınıf Ürünlerinin neye göre sıralanacağı.
    const [sepetePaketEkleMutation] = useSepetePaketEkleMutation({ refetchQueries: [SepetDocument] })

    const [selectedProducts, setSelectedProducts] = useState<SecilenUrun[]>([]) // Tablolarda seçilen ürünler bu state'e eklenir.
    const [selected1Products, setSelected1Products] = useState<SecilenUrun[]>([]) // Tablolarda seçilen ürünler bu state'e eklenir.
    const [selected2Products, setSelected2Products] = useState<SecilenUrun[]>([]) // Tablolarda seçilen ürünler bu state'e eklenir.
    const [selected3Products, setSelected3Products] = useState<SecilenUrun[]>([]) // Tablolarda seçilen ürünler bu state'e eklenir.
    const [selected4Products, setSelected4Products] = useState<SecilenUrun[]>([]) // Tablolarda seçilen ürünler bu state'e eklenir.

    const [modalVisible, setModalVisible] = useState(false)
    const [grupluUrunler, setGrupluUrunler] = useState<any[]>([])
    const [grupsuzUrunler, setGrupsuzUrunler] = useState<any[]>([])
    const [grupluAnaOkulUrunler, setGrupluAnaOkulUrunler] = useState<any[]>([])
    const [grupluIlkOkulUrunler, setGrupluIlkOkulUrunler] = useState<any[]>([])
    const [grupluOrtaOkulUrunler, setGrupluOrtaOkulUrunler] = useState<any[]>([])
    const [grupluLiseUrunler, setGrupluLiseUrunler] = useState<any[]>([])
    const [grupluUrunlerDersKategorili, setGrupluUrunlerDersKategorili] = useState<SinifUrunu[]>()
    // Sepete Ekle sırasında seçilmemiş model (varyant) ürünleri için sıralı zorunlu seçim akışı.
    // "Tümünü Seç" bu ürünleri atlayabildiğinden, veli seçim yapmadan sepete geçemesin diye
    // bu kuyruk boşalana kadar (tek tek, bir sonraki ürüne otomatik geçerek) seçim modalı gösterilir.
    const [zorunluModelKuyrugu, setZorunluModelKuyrugu] = useState<{ grupId: number; dersId: number; isim: string; products: SinifUrunu[] }[]>([])
    const zorunluModelDevamRef = useRef(false)
    // "İstemiyorum" denilen model grupları (dersId_grupId). handleSepeteEkleButton her
    // çağrıldığında model kontrolünü baştan hesapladığı için, reddedildiği bu sette
    // tutulmazsa aynı ürün her seferinde tekrar tekrar zorunlu seçim modalına düşer.
    const [reddedilenModelGruplari, setReddedilenModelGruplari] = useState<Set<string>>(new Set())
    // handleSepeteEkleButton "if (loading) return" satırından SONRA tanımlanıyor; aşağıdaki
    // useEffect ise (rules-of-hooks gereği) o satırdan ÖNCE, her render'da çağrılmalı. Bu yüzden
    // fonksiyona doğrudan değil, her render'da güncellenen bu ref üzerinden erişiyoruz.
    const handleSepeteEkleButtonRef = useRef<(() => void) | undefined>(undefined)
    // Zorunlu model kuyruğu tamamen boşalınca (son ürün de seçilince) sepete ekleme akışını
    // otomatik devam ettir. Bu sefer tüm modeller selectedProducts içinde olduğu için model
    // kontrolünü geçip normal şekilde sepete ekler.
    useEffect(() => {
        if (zorunluModelDevamRef.current && zorunluModelKuyrugu.length === 0) {
            zorunluModelDevamRef.current = false
            handleSepeteEkleButtonRef.current?.()
        }
    }, [zorunluModelKuyrugu])
    const navigate = useNavigate()
    const etiktetUrunId = ETIKET_URUN_ID
    const [sepetiBosalt] = useSepetiBosaltMutation()
    const { data: sepetData } = useSepetQuery({ variables: { slug: slug! } })
    const [isAModalVisible, setIsAModalVisible] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [optionsValue, setOptionsValue] = useState(-1)
    const [sinifSecimSifre] = useSinifSecimSifreMutation()
    const [showPasswordModal, setShowPasswordModal] = useState<boolean>(false)
    const [classPassword, setClassPassword] = useState<string>('')
    const [isPasswordChecked, setIsPasswordChecked] = useState(false)
    const isMobile = window.innerWidth <= 768
    const {data, loading, error} = useSinifUrunleriTestQuery({
        variables: {
            slug: slug!,
            sinif_id: sinifId,
        },
    })
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [temp, setTemp] = useState(false)
    const handlePasswordSubmit = async () => {
        try {
            const response = await sinifSecimSifre({
                variables: {
                    okul_id: data!.okul?.id!,
                    sinif_id: sinifId,
                    password: classPassword,
                },
            })

            if (response.data?.sinifSecimSifre) {
                const {statusCode, message} = response.data.sinifSecimSifre

                if (statusCode === 200) {
                    notification.open({
                        message: 'Başarılı',
                        description: 'Şifre Doğru.',
                        type: 'success',
                    })
                    setIsPasswordChecked(false)
                    setShowPasswordModal(false)
                } else {
                    notification.error({message: 'Hata', description: message})
                }
            }
        } catch (error) {
            notification.error({message: 'Hata', description: `${error}`})
        }
    }

    useEffect(() => {
        if (data?.okul?.sinif?.sifre_varmi === true) {
            setShowPasswordModal(true)
            setIsPasswordChecked(true)
        } else {
            setIsPasswordChecked(false)
        }
    }, [data])
    useEffect(() => {
        if (
            data?.okul?.tab_gosterim === false &&
            grupluUrunlerDersKategorili?.length === 0 &&
            grupsuzUrunler.length > 0
        ) {
            setInnerTabKey('2')
        }
    }, [data, grupluUrunlerDersKategorili, grupsuzUrunler])
    const closeDiv = () => {
        setTemp(false)
    }
    const showModal = () => {
        setIsModalVisible(true)
    }
    const handleCancel = () => {
        setIsModalVisible(false)
    }
    const showErrorModal = (message: string) => {
        setIsAModalVisible(true)
        const errorMessage = message ? message.slice(6) : message
        setErrorMessage(errorMessage)
    }

    const handleModalOk = () => {
        setIsAModalVisible(false)
        handleClear()
    }
    const handleClear = async () => {
        try {
            await sepetiBosalt({
                variables: {
                    okulSlug: slug!,
                },
            })
            notification.success({message: 'Başarı', description: 'Sepet başarılı bir şekilde güncellendi'})
            handleSepeteEkleButton()
        } catch (error) {
            notification.error({message: 'Hata', description: `${error}`})
        }
    }

    const handleModalCancel = () => {
        setIsAModalVisible(false)
    }

    useEffect(() => {
        showModal()
    }, [])

    useEffect(() => {
        const openNotification = (placement: NotificationPlacement, message: string) => {
            notification.open({
                message: 'Bilgilendirme',
                description: <p dangerouslySetInnerHTML={{__html: message}}/>,
                type: 'info',
                placement: placement,
            })
        }

        if (!loading && data) {
            if (data!.okul?.sinif?.aktif && data!.okul?.sinif?.kapali_uyarisi) {
                navigate(`/${AppRoutes.classClose}/${data.okul?.sinif?.id!}/`)
            }
            if (!data!.okul?.active) {
                // !data!.okul?.sinif?.aktif
                navigate(`/${AppRoutes.schoolClose}`)
            }

            if (data?.okul?.sinif?.uyari && data?.okul?.sinif?.uyari !== '') {
                // openNotification('topRight', data?.okul?.sinif?.uyari)
                setTemp(true)
            }
            if (data?.okul?.sinif?.duyuru_popup && data?.okul?.sinif?.duyuru_popup !== '') {
                openNotification('topRight', data?.okul?.sinif?.duyuru_popup)
            }

            //TODO: Kampanya ya istek attığından kampanya isteği dönüşü bilgi var ise gösterilebilir
            if (data?.okul?.sinif?.uye_indirim_var) {
                openNotification(
                    'topRight',
                    'Üyeliğinize özel indirimler fiyatlara yansıtılmıştır. Sınıf Listelerinde indirimli fiyat gösterilmektedir.',
                )
            }
        }
        // Data ayrımı
        // gruplu ve grupsuz olmasına göre
        const {sinif_urunleri_test} = data?.okul?.sinif || {}
        let innerGrupluUrunler: any[] = []
        let innerGrupsuzUrunler: any[] = []
        let innerGruplu1Urunler: any[] = []
        let innerGruplu2Urunler: any[] = []
        let innerGruplu3Urunler: any[] = []
        let innerGruplu4Urunler: any[] = []
        let grupluUrunlerDersKategorili: any[] = []

        if (sinif_urunleri_test) {
            sinif_urunleri_test.forEach((item) => {
                const hasTekstilKademesi = item?.urun?.urun_kademeleri && item.urun.urun_kademeleri !== ''
                // kategori.isim === 'Tekstil' → okul kıyafeti (Uzun Penye vb.)
                // Lab önlüğü gibi bedeni olan ama "Tekstil" kategorisinde olmayan ürünler kırtasiyede kalır
                const hasTekstilKategori = item?.urun?.kategori?.isim === 'Tekstil'
                const isTekstil = hasTekstilKademesi || hasTekstilKategori
                if (item?.urun?.grup !== null && isTekstil) {
                    if (item?.urun?.urun_kademeleri?.includes('1')) {
                        innerGruplu1Urunler.push(item)
                    }
                    if (item?.urun?.urun_kademeleri?.includes('2')) {
                        innerGruplu2Urunler.push(item)
                    }
                    if (item?.urun?.urun_kademeleri?.includes('3')) {
                        innerGruplu3Urunler.push(item)
                    }
                    if (item?.urun?.urun_kademeleri?.includes('4')) {
                        innerGruplu4Urunler.push(item)
                    }
                    if (data?.okul?.tekstil_toplu_satis === false) {
                        innerGrupluUrunler.push(item)
                    }
                } else {
                    innerGrupsuzUrunler.push(item)
                }
                innerGrupsuzUrunler.sort((a, b) => {
                    const posA = typeof a.position === 'number' ? a.position : 9999
                    const posB = typeof b.position === 'number' ? b.position : 9999
                    if (posA !== posB) return posA - posB
                    const bedenA = parseFloat(a.urun?.bilgiler?.find((bi: any) => bi.isim === 'Beden')?.deger ?? 'NaN')
                    const bedenB = parseFloat(b.urun?.bilgiler?.find((bi: any) => bi.isim === 'Beden')?.deger ?? 'NaN')
                    if (!isNaN(bedenA) && !isNaN(bedenB)) return bedenA - bedenB
                    return 0
                })
            })
        }

        // Gruoplu olan sınıf ürünlerini derse göre ayırma
        const grupluUrunlerKategorili = innerGrupluUrunler.reduce((acc, obj) => {
            const key = obj.ders.id
            acc[key] = acc[key] || []
            acc[key].push(obj)
            return acc
        }, {})
        grupluUrunlerDersKategorili = Object.values(grupluUrunlerKategorili).sort((a, b) => {
            const pri = (x: any[]) => (x[0].ders.id === -99 ? 0 : parseInt(x[0].ders.ders_sira || '9999', 10))

            return pri(a as any[]) - pri(b as any[])
        })
        setGrupluUrunler(innerGrupluUrunler)
        setGrupsuzUrunler(innerGrupsuzUrunler)
        setGrupluAnaOkulUrunler(innerGruplu1Urunler)
        setGrupluIlkOkulUrunler(innerGruplu2Urunler)
        setGrupluOrtaOkulUrunler(innerGruplu3Urunler)
        setGrupluLiseUrunler(innerGruplu4Urunler)
        setGrupluUrunlerDersKategorili(grupluUrunlerDersKategorili)
        // Zorunlu ürünlerin seçilmesi (grup varyantları modal ile seçilmeli, burada hariç)
        const zorunluUrunler = innerGrupsuzUrunler
            .filter((product: SinifUrunu) => product.min_adet! > 0 && !product.urun?.grup)
            .map((product: SinifUrunu) => {
                return {
                    isim: product.urun?.isim ?? '',
                    urunId: product.urun_id,
                    dersId: product.ders?.id,
                    resimler: product.urun?.resimler,
                    adet: product.adet ?? 1,
                    fiyat: product.indirimli_birim_fiyat, // Todo: Fiyat
                    minAdet: product.min_adet ?? 0,
                    maxAdet: getEffectiveMaxAdet(product.urun?.bilgiler, product.max_adet),
                    indirimsiz_birim_fiyat: product.indirimsiz_birim_fiyat,
                    indirimli_birim_fiyat: product.indirimli_birim_fiyat,
                    kisa_aciklama: product.urun?.kisa_aciklama,
                    grupId: null,
                    zorunlulukGrubu: product.zorunluluk_grubu ?? 0,
                    etiket_bilgisi: '',
                    secilenBeden: null,
                    kitapKaplama: product.urun?.kitap_kaplama,
                    grup: {
                        id: product.urun?.grup?.id ?? 0, // Adjust the property names as per your actual types
                        isim: product.urun?.grup?.isim ?? '',
                        resimler: product.urun?.grup?.resimler ?? [],
                        sira: product.urun?.grup?.sira ?? 0, // Assuming 'sira' is part of your UrunGrubu type
                    },
                } as SecilenUrun
            })
        if (!data?.okul?.sinif?.urunler_secili_gelsin) {
            setSelectedProducts(zorunluUrunler)
        } else {
            const tumUrunler = innerGrupsuzUrunler.filter((product: SinifUrunu) => !product.urun?.grup).map((product) => {
                return {
                    isim: product.urun?.isim ?? '',
                    urunId: product.urun_id,
                    dersId: product.ders?.id,
                    grupId: null,
                    adet: product.adet ?? 1,
                    resimler: product.urun?.resimler,
                    kisa_aciklama: product.urun?.kisa_aciklama,
                    indirimsiz_birim_fiyat: product.indirimsiz_birim_fiyat,
                    indirimli_birim_fiyat: product.indirimli_birim_fiyat,
                    fiyat: product.indirimli_birim_fiyat, // Todo: Fiyat
                    minAdet: product.min_adet ?? 0,
                    maxAdet: getEffectiveMaxAdet(product.urun?.bilgiler, product.max_adet),
                    zorunlulukGrubu: product.zorunluluk_grubu ?? 0,
                    etiket_bilgisi: '',
                    secilenBeden: '',
                    grup: {
                        id: product.urun?.grup?.id ?? 0, // Adjust the property names as per your actual types
                        isim: product.urun?.grup?.isim ?? '',
                        resimler: product.urun?.grup?.resimler ?? [],
                        sira: product.urun?.grup?.sira ?? 0, // Assuming 'sira' is part of your UrunGrubu type
                    },
                    kitapKaplama: product.urun?.kitap_kaplama,
                } as SecilenUrun
            })
            setSelectedProducts(tumUrunler)
        }
    }, [data])

    const handlePrint = () => {
        const printEl = document.querySelector('.print-only') as HTMLElement
        if (!printEl) return

        const html = `<!DOCTYPE html>
<html lang="tr">
<head>
  <meta charset="utf-8" />
  <title>İhtiyaç Listesi</title>
  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: Arial, sans-serif; padding: 24px; color: #222; }
    .print-header { display: flex; align-items: center; gap: 16px; border-bottom: 2px solid #333; padding-bottom: 12px; margin-bottom: 20px; }
    .print-logo { max-height: 60px; max-width: 120px; object-fit: contain; }
    .print-title h2 { font-size: 18px; font-weight: 700; margin-bottom: 4px; }
    .print-title h3 { font-size: 14px; color: #555; font-weight: 400; }
    .print-ders-group { margin-bottom: 16px; }
    .print-ders-baslik { background: #f0f0f0; padding: 4px 10px; font-size: 13px; font-weight: 600; border-left: 4px solid #333; margin-bottom: 4px; }
    table { width: 100%; border-collapse: collapse; font-size: 12px; }
    th, td { border: 1px solid #ccc; padding: 5px 8px; text-align: left; }
    th { background: #f5f5f5; font-weight: 600; }
    tr:nth-child(even) td { background: #fafafa; }
    .print-footer { margin-top: 20px; font-size: 10px; color: #888; text-align: right; border-top: 1px solid #ddd; padding-top: 8px; }
  </style>
</head>
<body>${printEl.innerHTML}</body>
</html>`

        const iframe = document.createElement('iframe')
        iframe.style.position = 'fixed'
        iframe.style.right = '0'
        iframe.style.bottom = '0'
        iframe.style.width = '0'
        iframe.style.height = '0'
        iframe.style.border = 'none'
        document.body.appendChild(iframe)

        iframe.srcdoc = html
        iframe.addEventListener('load', () => {
            iframe.contentWindow?.focus()
            iframe.contentWindow?.print()
            setTimeout(() => document.body.removeChild(iframe), 500)
        })
    }

    useEffect(() => {
        const onKeyDown = (e: KeyboardEvent) => {
            if (e.ctrlKey && e.key === 'b') {
                e.preventDefault()
                handlePrint()
            }
        }
        window.addEventListener('keydown', onKeyDown)
        return () => window.removeEventListener('keydown', onKeyDown)
    }, [])


    // Loading
    if (loading) {
        return <Spinner showSpinner={loading} color={'red'}></Spinner>
    }

    if (error) {
        navigate(`/`)
    }

    if (slug == null || sinifId === 0 || data === null || !sinifId || !slug) {
        // Todo: buraya sınıfta ürün yok olduğunu belirtecek bir component gelicek
        navigate(`/`)
    }

    const handleOrderSelectChange = (value: boolean) => {
        // Ürünlerin kırtasiye-ürün / ders-ürün sıralamasını değiştirir.
        setLessonGrouping(value)
    }

    const handleAccordionChange = (key: string | string[]) => {
        // Key parameter contains the key value of the opened panel
        const panelKey = typeof key === 'string' ? parseInt(key, 10) : key.map((k) => parseInt(k, 10))
        let a = 0

        // If panelKey is an array, set the first element, otherwise set the single value
        if (Array.isArray(panelKey)) {
            setOptionsValue(panelKey[0])
            a = panelKey[0]
        } else {
            setOptionsValue(panelKey)
            a = panelKey
        }
        const {sinif_urunleri_test} = data?.okul?.sinif || {}
        let innerGruplu1Urunler: any[] = []
        let innerGrupsuz1Urunler: any[] = []
        let innerGruplu2Urunler: any[] = []
        let innerGruplu3Urunler: any[] = []
        let innerGruplu4Urunler: any[] = []
        let innerGruplu5Urunler: any[] = []
        let grupluUrunler1DersKategorili: any[] = []
        if (a !== undefined && a >= 0) {
            if (a === 1) {
                innerGruplu2Urunler = grupluAnaOkulUrunler
                // Grouping class products by subject
                const grupluUrunler1Kategorili = innerGruplu2Urunler.reduce((acc, obj) => {
                    const key = obj.ders.id
                    acc[key] = acc[key] || []
                    acc[key].push(obj)
                    return acc
                }, {})
                grupluUrunler1DersKategorili = Object.values(grupluUrunler1Kategorili)
                setGrupluAnaOkulUrunler(innerGruplu2Urunler)
                setGrupluUrunlerDersKategorili(grupluUrunler1DersKategorili)
            } else if (a === 2) {
                innerGruplu3Urunler = grupluIlkOkulUrunler
                // Grouping class products by subject
                const grupluUrunler1Kategorili = innerGruplu3Urunler.reduce((acc, obj) => {
                    const key = obj.ders.id
                    acc[key] = acc[key] || []
                    acc[key].push(obj)
                    return acc
                }, {})
                grupluUrunler1DersKategorili = Object.values(grupluUrunler1Kategorili)
                setGrupluIlkOkulUrunler(innerGruplu3Urunler)
                setGrupluUrunlerDersKategorili(grupluUrunler1DersKategorili)
            } else if (a === 3) {
                innerGruplu4Urunler = grupluOrtaOkulUrunler
                // Grouping class products by subject
                const grupluUrunler1Kategorili = innerGruplu4Urunler.reduce((acc, obj) => {
                    const key = obj.ders.id
                    acc[key] = acc[key] || []
                    acc[key].push(obj)
                    return acc
                }, {})
                grupluUrunler1DersKategorili = Object.values(grupluUrunler1Kategorili)
                setGrupluOrtaOkulUrunler(innerGruplu4Urunler)
                setGrupluUrunlerDersKategorili(grupluUrunler1DersKategorili)
            } else if (a === 4) {
                innerGruplu5Urunler = grupluLiseUrunler
                // Grouping class products by subject
                const grupluUrunler1Kategorili = innerGruplu5Urunler.reduce((acc, obj) => {
                    const key = obj.ders.id
                    acc[key] = acc[key] || []
                    acc[key].push(obj)
                    return acc
                }, {})
                grupluUrunler1DersKategorili = Object.values(grupluUrunler1Kategorili)
                setGrupluLiseUrunler(innerGruplu5Urunler)
                setGrupluUrunlerDersKategorili(grupluUrunler1DersKategorili)
            }

            const filteredUrunler = data?.okul?.sinif?.sinif_urunleri_test?.filter((urun) =>
                urun?.urun?.urun_kademeleri?.includes(a.toString()),
            )
            if (filteredUrunler) {
                filteredUrunler.forEach((item) => {
                    if (item?.urun?.grup !== null) {
                        // handle grouped items
                    } else {
                        innerGrupsuz1Urunler.push(item)
                    }
                })
            }
            if (sinif_urunleri_test) {
                sinif_urunleri_test.forEach((item) => {
                    if (item?.urun?.grup === null) {
                        innerGrupsuz1Urunler.push(item)
                    }
                })
            }
            setGrupsuzUrunler(innerGrupsuz1Urunler)
        } else if (a === -1 || a === undefined) {
            if (sinif_urunleri_test) {
                sinif_urunleri_test.forEach((item) => {
                    if (item?.urun?.grup !== null) {
                        innerGruplu1Urunler = []
                    } else {
                        innerGrupsuz1Urunler.push()
                    }
                })
            }
            const grupluUrunler2Kategorili = innerGruplu1Urunler.reduce((acc, obj) => {
                const key = obj.ders.id
                acc[key] = acc[key] || []
                acc[key].push(obj)
                return acc
            }, {})
            grupluUrunler1DersKategorili = Object.values(grupluUrunler2Kategorili)
            setGrupluUrunler(innerGruplu1Urunler)
            setGrupsuzUrunler(innerGrupsuz1Urunler)
            setGrupluUrunlerDersKategorili(grupluUrunler1DersKategorili)
        } else {
            // Handle other cases if needed
        }
    }

    const handleSepeteEkleButton = async () => {
        // Sepette bu sınıfa ait mevcut ürünler
        const existingCartItems = (sepetData?.sepetTest?.urunler ?? [])
            .filter((item) => item?.sinif_id === sinifId)

        // Kıyafet sekmesinde ve bu sınıfa ait herhangi bir ürün sepette varsa: SADECE kıyafet ekle
        // Layout 1 (tab_gosterim===false): '1'=kıyafet, '2'=kitap
        // Layout 2 (tab_gosterim!==false): activeTab=0=kıyafet, 1=kitap
        const onKiyafetTab =
            (data?.okul?.tab_gosterim !== false && activeTab === 0) ||
            (data?.okul?.tab_gosterim === false && innerTabKey === '1')

        if (existingCartItems.length > 0 && onKiyafetTab) {
            // Kıyafet-only path: grupId !== null olanlar kıyafet, null olanlar kitap/kırtasiye
            // Layout 1'de kıyafet seçimleri selectedProducts'a da düşebilir
            const kiyafetSelectedItems = [
                ...selectedProducts.filter((p) => p.grupId !== null),
                ...selected1Products,
                ...selected2Products,
                ...selected3Products,
                ...selected4Products,
            ]

            // Beden seçilmemiş yeni kıyafet ürünü var mı?
            const bedenSecilmeyenler = kiyafetSelectedItems.filter(
                (p) =>
                    p.grupId !== null &&
                    p.secilenBeden == null &&
                    !existingCartItems.some((c) => c?.urun?.id === p.urunId),
            )
            if (bedenSecilmeyenler.length > 0) {
                bedenSecilmeyenler.forEach((el) => {
                    notification.warning({message: 'Uyarı', description: `${el.isim} ürününde beden seçimi yapınız.`})
                })
                return
            }

            const kiyafetItemsToAdd = kiyafetSelectedItems
                .map((p) => ({ urun_id: p.urunId, adet: p.adet, ogrenci_ismi: null as string | null }))
                .filter((item) => !existingCartItems.some((c) => c?.urun?.id === item.urun_id))

            if (kiyafetItemsToAdd.length === 0) {
                navigate(`/${AppRoutes.basket}?sinifId=${sinifId}`)
                return
            }
            try {
                await sepetePaketEkleMutation({
                    variables: { okul_slug: slug!, sinif_id: sinifId, urunler: kiyafetItemsToAdd },
                })
                if (data?.okul?.capraz_urun_satis_popupi_varmi) {
                    setModalVisible(true)
                } else {
                    navigate(`/${AppRoutes.basket}?sinifId=${sinifId}`)
                }
            } catch (error) {
                showErrorModal(`${error}`)
            }
            return
        }

        // Kitap sekmesine hiç gidilmemişse kıyafet-only sepete ekleme engellenir
        // Ancak okulun kitap/kırtasiye ürünü yoksa bu kontrol atlanır
        if (onKiyafetTab && !kitapTabVisited && grupsuzUrunler.length > 0) {
            notification.warning({
                message: 'Uyarı',
                description: 'Sepete eklemeden önce Kitap-Kırtasiye listesini incelemeniz gerekmektedir.',
            })
            return
        }

        // Normal path: kitap sekmesinden ekleme — tam validasyon
        const zorunluUrunler: SinifUrunu[] = grupsuzUrunler.filter((product: SinifUrunu) => product.min_adet! > 0 && !product.urun?.grup)
        const zorunluGruplar: number[] = grupluUrunler
            .filter((product: SinifUrunu) => product.zorunluluk_grubu !== null && product.zorunluluk_grubu !== undefined)
            .map((product: SinifUrunu) => product.zorunluluk_grubu as number)
            .filter((value: number, index: number, self: number[]) => self.indexOf(value) === index)

        let selectedProductsArray: { urun_id: number; adet: number; ogrenci_ismi: string | null }[] = []
        if (data?.okul?.tekstil_toplu_satis) {
            const collectSelectedProducts = (products: SecilenUrun[]) => {
                return products.map((product) => ({
                    urun_id: product.urunId,
                    adet: product.adet,
                    ogrenci_ismi: product.urunId === etiktetUrunId ? product.etiket_bilgisi : null,
                }))
            }
            selectedProductsArray.push(...collectSelectedProducts(selectedProducts))
            selectedProductsArray.push(...collectSelectedProducts(selected1Products))
            selectedProductsArray.push(...collectSelectedProducts(selected2Products))
            selectedProductsArray.push(...collectSelectedProducts(selected3Products))
            selectedProductsArray.push(...collectSelectedProducts(selected4Products))
        } else {
            selectedProductsArray = [
                ...selectedProducts,
                ...selected1Products,
                ...selected2Products,
                ...selected3Products,
                ...selected4Products,
            ].map((product) => ({
                urun_id: product.urunId,
                adet: product.adet,
                ogrenci_ismi: product.urunId === etiktetUrunId ? product.etiket_bilgisi : null,
            }))
        }
        console.log('selectedProducts', selectedProducts)
        console.log('selectedProductsArray', selectedProductsArray)

        // Sepette zaten olan ürünler tekrar gönderilmez
        const itemsToAdd = selectedProductsArray.filter(
            (item) => !existingCartItems.some((cartItem) => cartItem?.urun?.id === item.urun_id),
        )

        // Tüm grupsuz zorunlu ürünler: ya yeni eklenecekler arasında ya da sepette olmalı
        const isAllZorunluUrunlerSelected =
            zorunluUrunler.filter((zorunluUrun: SinifUrunu) =>
                itemsToAdd.some((item) => item.urun_id === zorunluUrun.urun_id) ||
                existingCartItems.some((cartItem) => cartItem?.urun?.id === zorunluUrun.urun_id),
            ).length === zorunluUrunler.length

        if (!isAllZorunluUrunlerSelected) {
            notification.warning({message: 'Uyarı', description: 'Listedeki zorunlu ürünlerin tamamı seçilmelidir.'})
            return
        }

        // Tüm gruplu zorunlu ürünler: ya seçilenler arasında ya da sepette olmalı
        const areAllZorunluGruplarSelected = zorunluGruplar.every((zorunluGrup: number) =>
            selectedProducts.some((selectedProduct) => selectedProduct.zorunlulukGrubu === zorunluGrup) ||
            existingCartItems.some((cartItem) =>
                grupluUrunler.some(
                    (gu: SinifUrunu) => gu.zorunluluk_grubu === zorunluGrup && gu.urun_id === cartItem?.urun?.id,
                ),
            ),
        )

        if (!areAllZorunluGruplarSelected) {
            const notSelectedGroups = zorunluGruplar.filter((grupId) => {
                const groupProducts: SinifUrunu[] = grupluUrunler.filter(
                    (product: SinifUrunu) => product.zorunluluk_grubu === grupId,
                )
                return !groupProducts.some((product: SinifUrunu) =>
                    selectedProductsArray.some((selectedProduct) => selectedProduct.urun_id === product.urun_id) ||
                    existingCartItems.some((cartItem) => cartItem?.urun?.id === product.urun_id),
                )
            })

            const uniqueGroupNames: Set<string> = new Set()
            notSelectedGroups.forEach((grupId) => {
                let groupProducts = grupluUrunler.filter((product: SinifUrunu) => product.zorunluluk_grubu === grupId)
                groupProducts.forEach((product: SinifUrunu) => {
                    let groupName = product.urun?.grup?.isim
                    if (groupName) {
                        uniqueGroupNames.add(groupName)
                    }
                })
            })

            const groupNamesArray = Array.from(uniqueGroupNames)
            notification.warning({
                message: 'Uyarı',
                description: (
                    <div>
                        <p style={{ marginBottom: 8, fontWeight: 500 }}>
                            Aşağıdaki ürün gruplarından en az birinin alınması zorunludur:
                        </p>
                        <ul style={{ paddingLeft: 20, margin: 0 }}>
                            {groupNamesArray.map((name, i) => (
                                <li key={i}>{name}</li>
                            ))}
                        </ul>
                    </div>
                ),
                placement: 'top',
                duration: 8,
            })
            return
        }

        // Beden kontrolü: sadece yeni eklenecek tekstil ürünleri
        const yeniTekstilUrunleri = [...selectedProducts, ...selected1Products, ...selected2Products, ...selected3Products, ...selected4Products].filter(
            (product) =>
                product.grupId !== null &&
                !existingCartItems.some((cartItem) => cartItem?.urun?.id === product.urunId),
        )
        const bedenSecilmeyenUrunler = yeniTekstilUrunleri.filter((product) => product.secilenBeden == null)
        if (bedenSecilmeyenUrunler.length > 0) {
            bedenSecilmeyenUrunler.forEach((element: SecilenUrun) => {
                notification.warning({message: 'Uyarı', description: `${element.isim} ürününde beden seçimi yapınız.`})
            })
            return
        }

        // Model kontrolü: kırtasiye/kitap sekmesindeki model (varyant) ürünlerinden hiç seçim
        // yapılmamış olanları bul. "Tümünü Seç" bu ürünleri bilerek atlıyor (seçim "Seçim Yap"
        // ile yapılmalı); bu kontrol olmadan veli fark etmeden bu ürünleri sepete hiç eklemeden
        // devam edebiliyordu (örn. sağ/sol el kalemleri). Sadece uyarı yetmiyor — veli o ürünü
        // bulup seçmeye üşenebiliyor — bu yüzden sırayla (önce kalem, sonra makas vs.) seçim
        // ekranını otomatik açıp seçim yaptırıyoruz; hepsi tamamlanınca sepete ekleme devam eder.
        const kirtasiyeModelGruplari: { grupId: number; dersId: number; isim: string; products: SinifUrunu[] }[] = (() => {
            const map = new Map<string, SinifUrunu[]>()
            grupsuzUrunler.forEach((p: SinifUrunu) => {
                const grupId = p.urun?.grup?.id
                const dersId = p.ders?.id
                if (grupId == null || dersId == null) return
                const key = `${dersId}_${grupId}`
                if (!map.has(key)) map.set(key, [])
                map.get(key)!.push(p)
            })
            const sonuc: { grupId: number; dersId: number; isim: string; products: SinifUrunu[] }[] = []
            map.forEach((prods, key) => {
                if (prods.length < 2) return // tekli ürün "model" sayılmaz, Seçim Yap gerektirmez
                const [dersIdStr, grupIdStr] = key.split('_')
                sonuc.push({
                    grupId: Number(grupIdStr),
                    dersId: Number(dersIdStr),
                    isim: prods[0].urun?.grup?.isim || prods[0].urun?.isim || 'Ürün',
                    products: prods,
                })
            })
            return sonuc
        })()

        const tumSeciliUrunler = [...selectedProducts, ...selected1Products, ...selected2Products, ...selected3Products, ...selected4Products]
        const secilmemisModelUrunleri = kirtasiyeModelGruplari.filter((grup) =>
            !reddedilenModelGruplari.has(`${grup.dersId}_${grup.grupId}`) &&
            !tumSeciliUrunler.some((sp) => sp.grupId === grup.grupId && sp.dersId === grup.dersId) &&
            !existingCartItems.some((cartItem) =>
                grupsuzUrunler.some(
                    (p: SinifUrunu) => p.urun?.grup?.id === grup.grupId && p.ders?.id === grup.dersId && p.urun_id === cartItem?.urun?.id,
                ),
            ),
        )
        if (secilmemisModelUrunleri.length > 0) {
            zorunluModelDevamRef.current = true
            setZorunluModelKuyrugu(secilmemisModelUrunleri)
            return
        }

        // Etiket kontrolü: sadece yeni eklenecekler arasında etiket varsa
        const etiketInItemsToAdd = itemsToAdd.some((item) => item.urun_id === etiktetUrunId)
        if (etiketInItemsToAdd) {
            const etiketUrunuSecimi = selectedProducts.filter((product) => product.urunId === etiktetUrunId)
            if (etiketUrunuSecimi.length > 0 && !etiketUrunuSecimi[0].etiket_bilgisi) {
                notification.warning({
                    message: 'Uyarı',
                    description: `${etiketUrunuSecimi[0].isim} ürününde etiket bilgileri eksik. Lütfen etiket bilgilerini giriniz.`,
                })
                return
            }
        }

        if (itemsToAdd.length === 0) {
            navigate(`/${AppRoutes.basket}?sinifId=${sinifId}`)
            return
        }
        try {
            await sepetePaketEkleMutation({
                variables: {
                    okul_slug: slug!,
                    sinif_id: sinifId,
                    urunler: itemsToAdd,
                },
            })
            if (data?.okul?.capraz_urun_satis_popupi_varmi) {
                setModalVisible(true)
            } else {
                navigate(`/${AppRoutes.basket}?sinifId=${sinifId}`)
            }
        } catch (error) {
            showErrorModal(`${error}`)
        }
    }
    // useEffect kuralları gereği (loading kontrolünden önceki hook'larla aynı sırada çağrılmalı)
    // handleSepeteEkleButton'a doğrudan değil, en tepede tanımlı ref üzerinden erişiyoruz.
    handleSepeteEkleButtonRef.current = handleSepeteEkleButton

    const handleZorunluModelSecim = (grup: { grupId: number; dersId: number; products: SinifUrunu[] }, product: SinifUrunu) => {
        const grupId = product.urun?.grup?.id ?? null
        const dersId = product.ders?.id!
        const groupUrunIds = new Set(grup.products.map((p) => p.urun_id))
        const yeniSecim: SecilenUrun = {
            isim: product.urun?.grup?.isim ?? product.urun?.isim ?? '',
            urunId: product.urun_id,
            dersId,
            adet: product.adet || 1,
            fiyat: product.indirimli_birim_fiyat ?? '',
            indirimsiz_birim_fiyat: product.indirimsiz_birim_fiyat ?? '',
            indirimli_birim_fiyat: product.indirimli_birim_fiyat ?? '',
            minAdet: product.min_adet ?? 0,
            maxAdet: getEffectiveMaxAdet(product.urun?.bilgiler, product.max_adet),
            grupId,
            zorunlulukGrubu: product.zorunluluk_grubu ?? 0,
            etiket_bilgisi: null,
            secilenBeden: product.urun?.bilgiler?.find((b) => b?.isim === 'Beden')?.deger ?? product.urun?.isim ?? '',
            kitapKaplama: product.urun?.kitap_kaplama ?? 0,
            kisa_aciklama: product.urun?.kisa_aciklama ?? '',
            grup: product.urun?.grup!,
            resimler: [...(product.urun?.resimler ?? [])],
        }
        setSelectedProducts((prev) => [
            ...prev.filter((sp) =>
                !(sp.grupId === grupId && sp.dersId === dersId) &&
                !(sp.grupId === null && groupUrunIds.has(sp.urunId) && sp.dersId === dersId),
            ),
            yeniSecim,
        ])
        setZorunluModelKuyrugu((prev) => prev.slice(1))
    }

    // Ürün zorunlu değilse veli "istemiyorum" diyebilir: hiçbir seçim eklenmeden kuyruktaki
    // bu ürün atlanır, sıradaki ürüne (varsa) geçilir; hepsi biterse sepete ekleme devam eder.
    // reddedilenModelGruplari'na eklemezsek, sepete ekleme akışı yeniden başladığında model
    // kontrolü bu ürünü tekrar "seçilmemiş" bulup modalı tekrar tekrar açardı.
    const handleZorunluModelIstemiyorum = () => {
        const current = zorunluModelKuyrugu[0]
        if (current) {
            setReddedilenModelGruplari((prev) => {
                const next = new Set(prev)
                next.add(`${current.dersId}_${current.grupId}`)
                return next
            })
        }
        setZorunluModelKuyrugu((prev) => prev.slice(1))
    }

    const zorunluModelSecimModal = (
        <Modal
            open={zorunluModelKuyrugu.length > 0}
            title={zorunluModelKuyrugu[0]?.isim || 'Model Seçiniz'}
            onCancel={() => {
                zorunluModelDevamRef.current = false
                setZorunluModelKuyrugu([])
            }}
            footer={null}
        >
            <p style={{ marginTop: -8, marginBottom: 12, color: '#555' }}>
                Bu ürünü sepetinize eklemediniz. Eklemek isterseniz lütfen seçim yapınız.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {(zorunluModelKuyrugu[0]?.products ?? []).map((product) => {
                    const variantLabel = product.urun?.bilgiler?.find((b) => b?.isim === 'Beden')?.deger || product.urun?.isim || ''
                    return (
                        <div
                            key={product.urun_id}
                            onClick={() => handleZorunluModelSecim(zorunluModelKuyrugu[0], product)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 12,
                                padding: '10px 14px',
                                border: '2px solid #e0e0e0',
                                borderRadius: 8,
                                cursor: 'pointer',
                                background: 'white',
                            }}
                        >
                            <img
                                src={product.urun?.resimler?.[0] || ''}
                                alt={variantLabel}
                                width={56}
                                height={56}
                                style={{ objectFit: 'contain' }}
                            />
                            <div style={{ fontWeight: 600 }}>{variantLabel}</div>
                        </div>
                    )
                })}
            </div>
            {zorunluModelKuyrugu[0] && !zorunluModelKuyrugu[0].products.some((p) => (p.min_adet ?? 0) > 0) && (
                <div style={{ marginTop: 14, textAlign: 'left' }}>
                    <span
                        onClick={() => handleZorunluModelIstemiyorum()}
                        style={{ fontSize: 12, color: '#999', textDecoration: 'underline', cursor: 'pointer' }}
                    >
                        Bu ürünü istemiyorum
                    </span>
                </div>
            )}
        </Modal>
    )

    const modalContent = (
        <div className="redirect-container">
            <h3>Size özel fiyatlı ürünlere göz atmak ister misiniz ?</h3>
            <div className="redirect-modal-content">
                <div className="image-container" onClick={() => navigate(`/${AppRoutes.crossproduct}/2167`)}>
                    <img className="modal-images" src={modalCantaImg} alt=""/>
                    <div className="modal-text">Çantalar</div>
                    <Link to={`/${AppRoutes.crossproduct}/2167`}>
                        Ürünleri İncele <RightCircleFilled/>{' '}
                    </Link>
                </div>
                <div className="image-container" onClick={() => navigate(`/${AppRoutes.crossproduct}/2159`)}>
                    <img className="modal-images" src={modalKalemImg} alt=""/>
                    <div className="modal-text">Kalemler</div>
                    <Link to={`/${AppRoutes.crossproduct}/2159`}>
                        Ürünleri İncele <RightCircleFilled/>{' '}
                    </Link>
                </div>
                <div className="image-container" onClick={() => navigate(`/${AppRoutes.crossproduct}/2173`)}>
                    <img className="modal-images" src={modalMataraImg} alt=""/>
                    <div className="modal-text">Mataralar</div>
                    <Link to={`/${AppRoutes.crossproduct}/2173`}>
                        Ürünleri İncele <RightCircleFilled/>{' '}
                    </Link>
                </div>
                <div className="image-container" onClick={() => navigate(`/${AppRoutes.crossproduct}/2168`)}>
                    <img className="modal-images" src={modalKalemKutuImg} alt=""/>
                    <div className="modal-text">Kalem Çantaları</div>
                    <Link to={`/${AppRoutes.crossproduct}/2168`}>
                        Ürünleri İncele <RightCircleFilled/>{' '}
                    </Link>
                </div>
            </div>
            <Button className="redirect-btn" onClick={() => navigate(`/${AppRoutes.basket}`)}>
                <ShoppingCartOutlined/> Sepete Git
            </Button>
        </div>
    )
    const getSelectedProducts = () => {
        switch (optionsValue) {
            case 1:
                return selected1Products
            case 2:
                return selected2Products
            case 3:
                return selected3Products
            case 4:
                return selected4Products
            default:
                return selectedProducts
        }
    }
    const getSelectedSetProducts = () => {
        switch (optionsValue) {
            case 1:
                return setSelected1Products
            case 2:
                return setSelected2Products
            case 3:
                return setSelected3Products
            case 4:
                return setSelected4Products
            default:
                return setSelectedProducts
        }
    }
    const renderProductTables = () => (
        <div className="product-tables">
            {grupluUrunlerDersKategorili &&
                grupluUrunlerDersKategorili.map((element: any, index: number) => (
                    <React.Fragment key={`${element[0].urun.grup.id}_grup_component`}>
                        {data?.okul?.tekstil_toplu_satis ? (
                            <GroupProductsTabTekstil
                                products={element}
                                selectedProducts={getSelectedProducts()}
                                setSelectedProducts={getSelectedSetProducts()}
                                indirimliFiyatGosterilsinmi={data?.okul?.indirimli_fiyat_gosterimi ?? false}
                                cokluSatis={true}
                            />
                        ) : (
                            <GroupProductsTab
                                products={element}
                                selectedProducts={getSelectedProducts()}
                                setSelectedProducts={getSelectedSetProducts()}
                                indirimliFiyatGosterilsinmi={data?.okul?.indirimli_fiyat_gosterimi ?? false}
                                cokluSatis={false}
                            />
                        )}
                    </React.Fragment>
                ))}
        </div>
    )

    // "kitap" kelimesi kategori isminde neredeyse hiç geçmiyor (örn. "Sözlük - Atlas - Yazım Kılavuzu"),
    // bu yüzden gerçek kitap ürünlerini kitap_kaplama adedi (>0) ile de tespit ediyoruz.
    const kirtasiyeTabLabel = grupsuzUrunler.some(
        (p: any) => (p.urun?.kitap_kaplama ?? 0) > 0 || p.urun?.kategori?.isim?.toLowerCase().includes('kitap')
    ) ? 'KİTAP-KIRTASİYE' : 'KIRTASİYE'

    const tabDatas1: TabData[] = [
        {
            label: (
                <div>
                    <img alt="" src={tabTekstilImg} width={25} height={25}
                         style={{paddingBottom: '1px', marginRight: '2px'}}/>
                    <span>OKUL KIYAFETİ</span>
                </div>
            ),
            className: 'okul-kiyafeti-tab',
            key: '1',
            content: (
                <Collapse
                    className="kademe-collapse"
                    accordion
                    onChange={(key) => {
                        const k = Array.isArray(key) ? key[0] : key
                        if (k) handleAccordionChange(k)
                    }}
                >
                    {[
                        { key: '1', label: 'Anaokulu' },
                        { key: '2', label: 'İlkokul' },
                        { key: '3', label: 'Ortaokul' },
                        { key: '4', label: 'Lise' },
                    ].map(({ key, label }) => (
                        <Collapse.Panel key={key} header={label}>
                            {optionsValue === parseInt(key) && (
                                <SchoolClothesPage
                                    grupluUrunler={grupluUrunlerDersKategorili}
                                    selectedProducts={getSelectedProducts()}
                                    setSelectedProducts={getSelectedSetProducts()}
                                    cokluSatis={false}
                                />
                            )}
                        </Collapse.Panel>
                    ))}
                </Collapse>
            ),
        },
        {
            label: (
                <div>
                    <img
                        alt=""
                        src={tabKirtasiyeImg}
                        width={25}
                        height={25}
                        style={{paddingBottom: '1px', marginRight: '2px'}}
                    />
                    <span>{kirtasiyeTabLabel}</span>
                </div>
            ),
            className: 'kitap-kirtasiye-tab',
            key: '2',
            content: (
                <div>
                    <div style={{display: 'flex', justifyContent: 'flex-end', padding: '8px 0 4px'}}>
                        <Select
                            className="order-select"
                            defaultValue={true}
                            onChange={handleOrderSelectChange}
                            options={[
                                {value: true, label: 'Derse Göre Sırala'},
                                {value: false, label: 'Kitap Kırtasiyeye Göre Sırala'},
                            ]}
                        />
                    </div>
                    <div className="product-tables">
                        <ClassProductsTable
                            products={grupsuzUrunler}
                            selectedProducts={selectedProducts}
                            setSelectedProducts={setSelectedProducts}
                            lessonGruping={lessonGrouping}
                            indirimliFiyatGosterilsinmi={data?.okul?.indirimli_fiyat_gosterimi ?? false}
                        />
                    </div>
                </div>
            ),
        },
    ]

    const tabDatas2: TabData[] = [
        {

            label: (
                <div>
                    <img alt="" src={tabTekstilImg} width={25} height={25}
                         style={{paddingBottom: '1px', marginRight: '2px'}}/>
                    <span>OKUL KIYAFETİ</span>
                </div>
            ),
            className: 'okul-kiyafeti-tab',
            key: '1',
            content: <div className="product-tables">{renderProductTables()}</div>,
        },
        {
            label: (
                <div>
                    <img
                        alt=""
                        src={tabKirtasiyeImg}
                        width={25}
                        height={25}
                        style={{paddingBottom: '1px', marginRight: '2px'}}
                    />
                    <span>{kirtasiyeTabLabel}</span>
                </div>
            ),
            className: 'kitap-kirtasiye-tab',
            key: '2',
            content: (
                <div>
                    <div style={{display: 'flex', justifyContent: 'flex-end', padding: '8px 0 4px'}}>
                        <Select
                            className="order-select"
                            defaultValue={true}
                            onChange={handleOrderSelectChange}
                            options={[
                                {value: true, label: 'Derse Göre Sırala'},
                                {value: false, label: 'Kitap Kırtasiyeye Göre Sırala'},
                            ]}
                        />
                    </div>
                    <div className="product-tables">
                        <ClassProductsTable
                            products={grupsuzUrunler}
                            selectedProducts={selectedProducts}
                            grupluUrunler={grupluUrunlerDersKategorili}
                            setSelectedProducts={setSelectedProducts}
                            lessonGruping={lessonGrouping}
                            indirimliFiyatGosterilsinmi={data?.okul?.indirimli_fiyat_gosterimi ?? false}
                        />
                    </div>
                </div>
            ),
        },
    ]

    const handleTabChange = (index: number) => {
        if (index === 1) setKitapTabVisited(true)
        setActiveTab(index)
    }
    console.log('aktif tab', activeTab)
    const printDersGruplari: Record<string, any[]> = grupsuzUrunler.reduce((acc: Record<string, any[]>, item: any) => {
        const k = item.ders?.isim || 'Genel'
        acc[k] = acc[k] || []
        acc[k].push(item)
        return acc
    }, {})

    const indirimliFiyatGoster = data?.okul?.indirimli_fiyat_gosterimi ?? false

    const printView = (
        <div className="print-only">
            <div className="print-header">
                {data?.okul?.logo && <img src={data.okul.logo} alt="Okul logosu" className="print-logo"/>}
                <div className="print-title">
                    <h2>{data?.okul?.isim}</h2>
                    <h3>{data?.okul?.sinif?.isim} — İhtiyaç Listesi</h3>
                </div>
            </div>
            {Object.entries(printDersGruplari).map(([dersIsim, products]) => (
                <div key={dersIsim} className="print-ders-group">
                    <div className="print-ders-baslik">{dersIsim}</div>
                    <table className="print-table">
                        <thead>
                        <tr>
                            <th>Ürün Adı</th>
                            <th>Açıklama</th>
                            <th>Adet</th>
                            <th>Fiyat</th>
                        </tr>
                        </thead>
                        <tbody>
                        {products.map((item: any, idx: number) => {
                            const fiyat = indirimliFiyatGoster ? item.indirimli_birim_fiyat : item.indirimsiz_birim_fiyat
                            return (
                                <tr key={idx}>
                                    <td>{item.urun?.isim}</td>
                                    <td>{item.urun?.kisa_aciklama}</td>
                                    <td>{item.adet}</td>
                                    <td>{fiyat ? `${fiyat} ₺` : '—'}</td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                </div>
            ))}
            <p className="print-footer">OkulSepeti &bull; {new Date().toLocaleDateString('tr-TR')}</p>
        </div>
    )

    // Sepette bu sınıfa ait herhangi bir ürün varsa kıyafet sekmesinde "Diğer Sayfaya Geç" gösterme
    const existingCartItemsForSinif = (sepetData?.sepetTest?.urunler ?? [])
        .filter((item) => item?.sinif_id === sinifId)
    const booksAlreadyInCart = existingCartItemsForSinif.length > 0

    if (data?.okul?.tab_gosterim === false) {
        return (
            <CenteredLayout maxWidth={1300}>
                {!isPasswordChecked ? (
                    <>
                        {temp && (
                            <Modal title="Bilgilendirme" open={isModalVisible} className="uyari-modal"
                                   onCancel={handleCancel}>
                                <p className="okul-yazi"
                                   dangerouslySetInnerHTML={{__html: data?.okul?.sinif?.uyari || ''}}/>
                            </Modal>
                        )}
                        <Modal
                            title="Uyarı!"
                            visible={isAModalVisible}
                            onOk={handleModalOk}
                            cancelText={'Sepetime Dokunma'}
                            okText={'Sepeti Güncelle'}
                            onCancel={handleModalCancel}
                        >
                            <p>{errorMessage}</p>
                        </Modal>
                        <div className="sinif-baslik-container">
                            <h1>Sınıf İhtiyaç Listesi </h1>
                            <h3>{data?.okul?.sinif?.isim} </h3>
                        </div>
                        {temp && (
                            <div
                                style={{
                                    border: '1px solid #ddd',
                                    backgroundColor: '#dff2ff',
                                    padding: '10px',
                                    position: 'relative',
                                }}
                            >
                                <Button type="text" onClick={closeDiv}
                                        style={{position: 'absolute', top: '5px', right: '5px'}}>
                                    X
                                </Button>
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <img
                                        alt=""
                                        src={infoImg}
                                        width={25}
                                        height={25}
                                        style={{paddingBottom: '1px', marginRight: '30px'}}
                                    />
                                    <p
                                        style={{color: '#3c5d90', margin: '0'}}
                                        dangerouslySetInnerHTML={{__html: data?.okul?.sinif?.uyari || ''}}
                                    />
                                </div>
                            </div>
                        )}
                        <div className="product-tables">
                            <ClassProductsTable
                                selectedProducts={selectedProducts}
                                setSelectedProducts={setSelectedProducts}
                                products={grupsuzUrunler}
                                grupluUrunler={grupluUrunlerDersKategorili ?? []}
                                lessonGruping={lessonGrouping}
                                indirimliFiyatGosterilsinmi={data?.okul?.indirimli_fiyat_gosterimi ?? false}
                                activeTabKey={innerTabKey}
                                onTabChange={(key) => { if (key === '2') setKitapTabVisited(true); setInnerTabKey(key) }}
                            />
                        </div>

                        <div style={{display: 'flex', marginTop: '15px', marginBottom: '20px', justifyContent: 'end'}}>
                            <div style={{maxWidth: '250px', width: '200px'}}>
                                {grupluUrunlerDersKategorili &&
                                grupluUrunlerDersKategorili.length > 0 &&
                                grupsuzUrunler.length > 0 &&
                                innerTabKey === '1' &&
                                !booksAlreadyInCart ? (
                                    <Button
                                        type="primary"
                                        style={{width: '100%'}}
                                        className="button-new-color"
                                        onClick={() => setInnerTabKey('2')}
                                    >
                                        Diğer Sayfaya Geç
                                    </Button>
                                ) : (
                                    <Button
                                        type="primary"
                                        style={{width: '100%'}}
                                        className="button-new-color"
                                        onClick={handleSepeteEkleButton}
                                    >
                                        <ShoppingCartOutlined/>
                                        Sepete Ekle
                                    </Button>
                                )}
                            </div>
                        </div>

                        {data?.okul?.capraz_urun_satis_popupi_varmi && (
                            <Modal
                                open={modalVisible}
                                title="Hazır Okul Alışverişindeyken,"
                                className="redirect-modal"
                                onOk={() => setModalVisible(false)}
                                getContainer={false}
                                onCancel={() => setModalVisible(false)}
                                footer={null} // Cancel butonunu kaldırmak için
                                width={isMobile ? '100%' : 1000}
                            >
                                {modalContent}
                            </Modal>
                        )}
                        {zorunluModelSecimModal}
                    </>
                ) : null}
                <Modal
                    centered
                    title="Sınıf Şifresi"
                    open={showPasswordModal}
                    onOk={handlePasswordSubmit}
                    onCancel={() => setShowPasswordModal(false)}
                    okText="Gönder"
                    cancelText="İptal"
                    destroyOnClose
                >
                    <Input.Password
                        placeholder="Sınıf şifresi giriniz"
                        value={classPassword}
                        onChange={(e) => setClassPassword(e.target.value)}
                    />
                </Modal>
                {printView}
            </CenteredLayout>
        )
    } else {
        return (
            <CenteredLayout maxWidth={1300}>
                {!isPasswordChecked ? (
                    <>
                        {temp && (
                            <Modal title="Bilgilendirme" open={isModalVisible} className="uyari-modal"
                                   onCancel={handleCancel}>
                                <p className="okul-yazi"
                                   dangerouslySetInnerHTML={{__html: data?.okul?.sinif?.uyari || ''}}/>
                            </Modal>
                        )}
                        <Modal
                            title="Uyarı!"
                            visible={isAModalVisible}
                            onOk={handleModalOk}
                            cancelText={'Sepetime Dokunma'}
                            okText={'Sepeti Güncelle'}
                            onCancel={handleModalCancel}
                        >
                            <p>{errorMessage}</p>
                        </Modal>
                        <div className="sinif-baslik-container">
                            <h1>Sınıf İhtiyaç Listesi</h1>
                            <h3>{data?.okul?.sinif?.isim}</h3>
                        </div>
                        <div className="tab-container">
                            <div id="tab-bar" className="tab-bar">
                                {(data?.okul?.tekstil_toplu_satis ? tabDatas1 : tabDatas2)
                                    .filter((_, index) => index === 0 || grupsuzUrunler.length > 0)
                                    .map((tab, _, arr) => {
                                        const originalIndex = (data?.okul?.tekstil_toplu_satis ? tabDatas1 : tabDatas2).indexOf(tab)
                                        return (
                                            <div
                                                key={tab.key}
                                                className={`tab ${tab.className}${activeTab === originalIndex ? ' active-tab' : ''}`}
                                                onClick={() => handleTabChange(originalIndex)}
                                            >
                                                {tab.label}
                                            </div>
                                        )
                                    })}
                            </div>
                            {temp && (
                                <div
                                    style={{
                                        border: '1px solid #ddd',
                                        backgroundColor: '#dff2ff',
                                        padding: '10px',
                                        position: 'relative',
                                    }}
                                >
                                    <Button type="text" onClick={closeDiv}
                                            style={{position: 'absolute', top: '5px', right: '5px'}}>
                                        X
                                    </Button>
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                        <img
                                            alt=""
                                            src={infoImg}
                                            width={25}
                                            height={25}
                                            style={{paddingBottom: '4px', marginRight: '30px'}}
                                        />
                                        <p
                                            style={{color: '#3c5d90', margin: '0'}}
                                            dangerouslySetInnerHTML={{__html: data?.okul?.sinif?.uyari || ''}}
                                        />
                                    </div>
                                </div>
                            )}
                            {data?.okul?.tekstil_toplu_satis
                                ? optionsValue <= 0 &&
                                activeTab === 0 && (
                                    <div style={{paddingTop: 5}}>
                                        <Alert
                                            type={'error'}
                                            closable={false}
                                            message={
                                                'Sınıf Listelerine ulaşmak için öğrencinin kayıtlı olduğu sınıf kademesi seçilmelidir.'
                                            }
                                        ></Alert>
                                    </div>
                                )
                                : null}
                            {data?.okul?.tekstil_toplu_satis === true ? (
                                <div className="tab-content">{tabDatas1[activeTab].content}</div>
                            ) : (
                                <div className="tab-content">{tabDatas2[activeTab].content}</div>
                            )}
                        </div>

                        <div style={{display: 'flex', marginTop: '15px', marginBottom: '20px', justifyContent: 'end'}}>
                            <div style={{maxWidth: '250px', width: '200px'}}>
                                {activeTab === 0 && grupsuzUrunler.length > 0 && !booksAlreadyInCart ? (
                                    <Button
                                        type="primary"
                                        style={{width: '100%'}}
                                        className="button-new-color"
                                        onClick={() => setActiveTab(1)}
                                    >
                                        Diğer Sayfaya Geç
                                    </Button>
                                ) : (
                                    <Button
                                        type="primary"
                                        style={{width: '100%'}}
                                        className="button-new-color"
                                        onClick={handleSepeteEkleButton}
                                    >
                                        <ShoppingCartOutlined/>
                                        Sepete Ekle
                                    </Button>
                                )}
                            </div>
                        </div>

                        {data?.okul?.capraz_urun_satis_popupi_varmi && (
                            <Modal
                                open={modalVisible}
                                title="Hazır Okul Alışverişindeyken,"
                                className="redirect-modal"
                                onOk={() => setModalVisible(false)}
                                onCancel={() => setModalVisible(false)}
                                footer={null} // Cancel butonunu kaldırmak için
                                width={1000}
                                getContainer={false}
                            >
                                {modalContent}
                            </Modal>
                        )}
                        {zorunluModelSecimModal}
                    </>
                ) : null}
                <Modal
                    centered
                    title="Sınıf Şifresi"
                    open={showPasswordModal}
                    onOk={handlePasswordSubmit}
                    onCancel={() => setShowPasswordModal(false)}
                    okText="Gönder"
                    cancelText="İptal"
                    destroyOnClose
                >
                    <Input.Password
                        placeholder="Sınıf şifresi giriniz"
                        value={classPassword}
                        onChange={(e) => setClassPassword(e.target.value)}
                    />
                </Modal>
                {printView}
            </CenteredLayout>
        )
    }
}

export default ClassProductsPage
